module.exports = __webpack_public_path__ + "static/media/Eclipse-0.6s-76px.c6fa9a18.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/Eclipse-0.6s-76px.gif
// module id = 34
// module chunks = 0